import React, { useEffect, useState } from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { IconEdit, IconList } from '../../../../../../shared/icon/icon'
import { Menu, MenuDelete, MenuItem } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { useApiFormAppStore, useApiListAppVersion } from '../../../../../../api-new/state/config'
import { FormSimple, useForm } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleURL } from '../../../../../../shared/form-simple/form-url'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { Label } from '../../../../../../shared/form-simple/common/label'

export const AppStoreEdit = () => {
  const { appID, appStoreID } = useParamsInt()

  const apiFormAppStore = useApiFormAppStore()

  const handlePath = () => apiFormAppStore.get(appStoreID)

  const handleSubmit = async data => apiFormAppStore.put(data.id, data)

  const roleSysApp = useRoleSysApp()

  const HeaderMenu = () =>
    <Menu>
      <MenuItem Icon={IconList} text="versions" to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/version`} show={roleSysApp.accessCreate} pin />
      <MenuDelete to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/delete`} show={roleSysApp.accessDelete} />
    </Menu>

  const [currentData, updateCurrentData] = useState({})

  const handleChange = data => updateCurrentData(data)

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text={apiFormAppStore.form.name} onPath={handlePath}>
        <CardFullHeightScrollY title={apiFormAppStore.form.name} HeaderMenu={HeaderMenu}>
          <FormSimple state={apiFormAppStore.form} onSubmit={handleSubmit} onChange={handleChange}>
            <FormSimpleText name="key" readonly />
            <FormSimpleText name="name" />
            <AppVersionSelectNew name="currentVersionID" appStoreID={appStoreID} />
            <FormSimpleURL label="download proxy URL" name="appStoreProxyURL" readonly />
            <SelectDownloadType name="downloadType" />
            {currentData.downloadType === 'store' && <FormSimpleURL label="store url" name="storeURL" />}
            <FormSimpleSubmitEdit />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}

const AppVersionSelectNew = ({ name, appStoreID }) => {
  const { register } = useForm(name, { valueAsNumber: true, shouldDirty: true })

  const apiListAppVersion = useApiListAppVersion()

  useEffect(
    () => {
      appStoreID && apiListAppVersion.get(`${appStoreID}/store`)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [appStoreID]
  )

  return (
    <Label label="app version" name={name}>
      <select className="form-control" {...register()}>
        <option value={0}>latest version</option>
        {apiListAppVersion.items.map((item, i) =>
          <option key={i} value={item.id} disabled={!item.isActive}>
            {item.name}
          </option>
        )}
      </select>
    </Label>
  )
}

const SelectDownloadType = ({ name }) => {
  const { register } = useForm(name, { shouldDirty: true })

  return (
    <Label label="download type" name={name}>
      <select className="form-control" {...register()}>
        <option value="">Select</option>
        <option value="edxr">Edxr Download Page</option>
        <option value="direct">Direct Download</option>
        <option value="store">Store URL</option>
      </select>
    </Label>
  )
}
